<template>
    <div class="today-task-container">
        <div class="task-bar" v-for="(item, index) in barList" :key="index">
            <div class="number">{{ item.value }}</div>
            <div class="bar">
                <div
                        class="bar-inner"
                        :style="{ height: `${computePercent(item.value)}%`, background: `${colors[index]}` }"
                >
                </div>
            </div>
            <div class="label">{{ item.label }}</div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      data: Array
    },
    data() {
      return {
        total: 0,
        barList: [],
        colors: ['#FFCE56', '#B786FB', '#FC6363', '#64E7FF']
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      computePercent(num) {
        if (this.total === 0) return 0
        let percent = (num / this.total) * 100
        return percent.toString().substr(0, 4)
      },
      init() {
        this.data.forEach((rank) => {
          this.barList.push({
            label: rank['name'],
            value: rank['value']
          })
        })
        this.barList.filter((bar) => bar.value !== undefined)
        this.total = this.barList.reduce((t, c) => t + c.value, 0)
      }
    },
    watch: {
      data() {
        this.init()
      }
    }
  }
</script>


<style lang="less" scoped>
    .today-task-container {
        width: 100%;
        height: 370px;
        display: flex;
        justify-content: space-around;

        .task-bar {
            height: 370px;
            flex: 1;
            text-align: center;
            .label {
                color: #333;
            }

            .bar {
                margin: 15px auto;
                width: 14px;
                height: 280px;
                background: #F2F2F2;
                border-radius: 7px;
                display: flex;
                align-items: flex-end;
                .bar-inner {
                    border-radius: 10px;
                    /*min-height: 20px;*/
                    width: 14px;
                }
            }
        }
    }
</style>
